// extracted by mini-css-extract-plugin
module.exports = {"exportButton":"SalesDetails_exportButton__2FbB4","rangePicker":"SalesDetails_rangePicker__2t4Ip"};